<template>
  <div class="stockReport">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">库存报表</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>日期&nbsp;&nbsp;</span>
            <el-date-picker
              size="small"
              v-model="start"
              type="date"
              :clearable="false"
              placeholder="开始日期"
              @change="changeTime(0)"
              value-format="yyyy-MM-dd"
              :picker-options="pickerTimeOptions"
            >
            </el-date-picker>
          </div>
          <div
            class="select-container-box"
            style="padding: 0 5px"
          >
            <span>至</span>
          </div>
          <div
            class="select-container-box"
            style="padding: 0 1px"
          >
            <el-date-picker
              size="small"
              v-model="end"
              type="date"
              :clearable="false"
              placeholder="结束日期"
              @change="changeTime(1)"
              value-format="yyyy-MM-dd"
              :picker-options="pickerTimeOptions"
            >
            </el-date-picker>
          </div>
          <div class="select-container-box">
            <span>基地&nbsp;&nbsp;</span>
            <el-select
              v-model="fishBaseId"
              filterable
              placeholder="请选择"
              size="small"
              @change="baseChange"
            >
              <el-option
                v-for="(item, index) in baseList"
                :key="index"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>在&nbsp;&nbsp;</span>
            <el-select
              v-model="type"
              filterable
              size="small"
            >
              <el-option
                v-for="(item, index) in typeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input
              placeholder="请输入关键字"
              v-model="keyword"
              prefix-icon="el-icon-search"
              size="small"
              type="text"
              :maxlength="20"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              class="search-input"
              clearable
            >
            </el-input>
          </div>
          <div
            class="select-container-box"
            v-if="(canEditAll = true)"
          >
            <el-button
              size="small"
              type="info"
              plain
              @click="search"
              class="query"
            >查询</el-button>

            <ExportExcelBtn
              apiUrl="/api/StockReport/ExportStockReport"
              :queryParamsObj="queryParams"
              fileName="库存报表.xls"
            />
          </div>
        </div>
      </div>
      <div class="table-container">
        <!-- 表头 -->
        <table
          class="table-package"
          :class="isTop ? 'fix' : ''"
        >
          <thead class="table-thead">
            <tr>
              <th>物资大类</th>
              <th>物资类型</th>
              <th>物资名称</th>
              <th>规格</th>
              <th>计量单位</th>
              <th>期初结余数量</th>
              <th>期初结余金额</th>
              <th>本期采购数量</th>
              <th>本期采购均价</th>
              <th>本期采购金额</th>
              <th>本期耗用数量</th>
              <th>本期耗用金额</th>
              <th>本期结余数量</th>
              <th>本期结余均价</th>
              <th>本期结余金额</th>
            </tr>
          </thead>
        </table>
        <!-- 表体 -->
        <div
          class="scroll-box"
          ref="scrollBox"
        >
          <table class="table-package">
            <tbody
              class="table-tbodys"
              v-if="list.length !== 0"
            >
              <tr
                v-for="(item, index) in list"
                :key="index"
              >
                <td>{{ item.category }}</td>
                <td>{{ item.kind }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.spec }}</td>
                <td>{{ item.unit }}</td>
                <td>{{ item.lastCount }}</td>
                <td>{{ item.lastAmount }}</td>
                <td>{{ item.purchase }}</td>
                <td>{{ item.avgPrice }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.consume }}</td>
                <td>{{ item.consumeAmount }}</td>
                <td>{{ item.count }}</td>
                <td>{{ item.countAvgPrice }}</td>
                <td>{{ item.countAmount }}</td>
              </tr>
            </tbody>
            <tbody
              class="table-tbodys"
              v-if="list.length === 0"
            >
              <tr>
                <td colspan="15">该时间段暂无数据</td>
              </tr>
            </tbody>
          </table>
          <!-- 表尾 -->
          <table class="table-package">
            <tfoot
              class="table-tfoot"
              v-if="list.length !== 0"
            >
              <tr class="row">
                <td>合计</td>
                <td>--</td>
                <td>--</td>
                <td>--</td>
                <td>--</td>

                <td>{{ total("lastCount").toFixed(2) }}</td>
                <td>{{ total("lastAmount").toFixed(2) }}</td>
                <td>{{ total("purchase").toFixed(2) }}</td>
                <td>{{ footerPurchaseAvgPrice }}</td>
                <td>{{ total("amount").toFixed(2) }}</td>
                <td>{{ total("consume").toFixed(2) }}</td>
                <td>{{ total("consumeAmount").toFixed(2) }}</td>
                <td>{{ total("count").toFixed(2) }}</td>
                <td>{{ footerCountAvgPrice }}</td>
                <td>{{ total("countAmount").toFixed(2) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../store";
import { MessageBox, Message } from "element-ui";
import checkPermission from "../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import ExportExcelBtn from "../common/ExportExcelBtn";
import { resolveFishBaseKeyFromList, fishBaseIdForQuery } from "@/common/resolveFishBaseSelection.js";
export default {
  mixins: [mixins],
  name: "StockReport",
  components: { ExportExcelBtn },
  data () {
    return {
      start: "", //开始时间
      end: "", //结束时间
      pickerTimeOptions: {
        // 限制日期
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      fishBaseId: "", //基地
      baseList: [], //基地列表
      type: "",

      typeList: [
        {
          value: "",
          label: "全部",
        },
        {
          label: "饲料",
          value: "10001",
        },
        {
          label: "渔药",
          value: "10002",
        },
        {
          label: "疫苗",
          value: "10003",
        },
      ],
      keyword: "", //查找
      list: [],
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10, // 当前页数
      },
      isTop: false,
      fixWidth: 0,
    };
  },
  //默认时间
  created () {
    let startTime = localStorage.getItem("start");
    let endTime = localStorage.getItem("end");
    if (startTime) {
      this.start = this.$timeformatDay(startTime);
    } else {
      const start = new Date();
      start.setDate(1);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = this.$timeformatDay(endTime);
    } else {
      this.end = this.$timeformatDay(new Date());
    }
  },
  async mounted () {
    // 监听滚动
    window.addEventListener("scroll", this.getScroll, true);
    // 设置表头宽度
    this.fixWidth = this.$refs.scrollBox.offsetWidth - 5;
    window.onresize = () => {
      return (() => {
        this.fixWidth = this.$refs.scrollBox.offsetWidth;
      })();
    };

    this.baseList = await this.getAllBaseList({
      forQueryAll: true,
      allOptionItem: { key: -1 },
    });
    this.fishBaseId = resolveFishBaseKeyFromList(
      this.baseList,
      localStorage.getItem("base")
    );
    this.search();
  },
  methods: {
    //监听滚动
    getScroll () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 180) {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    },

    ...mapActions(modules.base, ["getAllBaseList"]), //基地
    ...mapActions(modules.report, {
      getStockReport: "getStockReport",
    }),
    changeTime (type) {
      if (type == 0) {
        localStorage.setItem("start", this.start);
      } else {
        localStorage.setItem("end", this.end);
      }
    },
    baseChange (e) {
      localStorage.setItem("base", e);
    },
    //查询
    search (pageNum) {
      this.getStockReport(this.queryParams)
        .then((rsp) => {
          console.log(rsp);
          this.list = rsp;
        })
        .catch((err) => {
          console.dir(err);
        });
    },
    //总计
    total (prop) {
      let total = 0;
      // this.reportData.forEach(item => (total += Number(item[prop])));
      // this.reportData.forEach(item => {
      //   if (item.quantity) {
      //     total += item.quantity;
      //   }
      // });
      this.list.forEach((item) => (total += Number(item[prop])));
      return total;
    },
    //合并--显示格式
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (
          index === 1 ||
          index === 2 ||
          index === 3 ||
          index === 4 ||
          index === 7
        ) {
          sums[index] = "--";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2) + " ";
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
  },
  computed: {
    queryParams () {
      let obj = {
        BaseId: fishBaseIdForQuery(this.fishBaseId, this.baseList),
        startDate: this.start,
        endDate: this.end,
        category: this.type,
        queryString: this.keyword,
      };
      return obj;
    },
    footerPurchaseAvgPrice () {
      const sumPurchase = this.total("purchase");
      const sumAmount = this.total("amount");
      if (!sumPurchase) {
        return "0.00";
      }
      return (sumAmount / sumPurchase).toFixed(2);
    },
    footerCountAvgPrice () {
      const sumCount = this.total("count");
      const sumAmount = this.total("countAmount");
      if (!sumCount) {
        return "0.00";
      }
      return (sumAmount / sumCount).toFixed(2);
    },
  },
};
</script>
<style lang="stylus">
.stockReport {
  .scroll-box {
    width: 100%;
  }

  .table-package {
    width: 100%;
    border-collapse: collapse;
    border: none;
  }

  .table-thead {
    border-top: 2px solid rgb(51, 137, 255);

    > tr th {
      width: 6.66666667%;
      text-align: center;
      height: 50px;
      font-size: 14px;
      line-height: 50px;
      color: #666;
      font-weight: bold;
      border: 1px solid #e0e0e0;
      border-bottom: 1px solid rgb(51, 137, 255);
      background-color: #f7f7f7;
    }
  }

  .table-tbodys {
    :hover {
      background: #c3e3ff;
    }

    tr {
      text-align: center;
      height: 37px;
      line-height: 37px;
      border: 1px solid #ddd;
      border: none;
      background-color: #fff;
    }

    td {
      width: 6.66666667%;
      border: 1px solid #e0e0e0;
      border-top: none;
      color: #666;
    }
  }

  .table-tfoot {
    tr>td {
      text-align: center;
      height: 37px;
      line-height: 37px;
      color: #333;
      font-size: 14px;
    }

    .row {
      font-size: 14px;
      background-color: #fff;
      font-weight: bold;

      >td {
        width: 6.66666667%;
        text-align: center;
        border: 1px solid #e0e0e0;
        // color #666
        border-top: none;
        font-weight: bold;
      }
    }
  }

  .hidden {
    display: none;
  }
}

.stockReport .table-package.fix {
  color: #666;
  position: fixed;
  z-index: 1000;
  top: 0px;
  width: calc(100% - 250px);
}
</style>
